import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import Image from "../components/image"



const NavbarLinks = (props) => {
  return (
    <ul className={props.page == "home" ? "home" : ''}>
      <li>
        <Link to="/">
          <p>Top</p>
        </Link>
      </li>
      <li>
        <Link to="/artists/">
          <p>作家一覧</p>
        </Link>
      </li>
      <li>
        <Link to="/artists/zone1/">
          <p>zone1</p>
        </Link>
      </li>
      <li>
        <Link to="/artists/zone2/">
          <p>zone2</p>
        </Link>
      </li>
      <li>
        <Link to="/artists/zone3/">
          <p>zone3</p>
        </Link>
      </li>
      <li>
        <Link to="/search/">
          <p>検索 / さくいん</p>
        </Link>
      </li>
      <li className={'image_in'}>
        <Link to="/about/">
          <Image src='ssslogo-fill-white.svg' className={'menu-icon white'} />
          <Image src='ssslogo-fill-purple.svg' className={'menu-icon purple'} />
          <Image src='ssslogo-fill-ice.svg' className={'menu-icon ice'} />
        </Link>
      </li>
    </ul>
  )
}

const Foot = (page) => {
  const [NavbarOpen, setNavbarOpen] = useState(false)


  var classname = ""
  if (page.page == "home") {
    classname += "white "
  }
  if (NavbarOpen) {
    classname += "active "
  }
  const handle = () => {
    setNavbarOpen(!NavbarOpen)
    return false;
  }

  return (
    <footer className={classname} id="footer" >
      <a
        open={NavbarOpen}
        onClick={handle}
      >
        <div className={"menu_button"}>
          <span />
          <span />
          <span />
        </div>

        <p className={"close_button"}>
          とじる
        </p>
      </a>
      <NavbarLinks page={page.page} />
    </footer>
  )
}


Foot.propTypes = {
  page: PropTypes.string,
}

Foot.defaultProps = {
  page: ``,
}


export default Foot
